/* Magaranger Slide Cart - Sep 16 2026
 * Replaces the /cart redirect with a slide-out drawer. All adds use Shopify's
 * Ajax Cart API (/cart/add.js) so Shopify customer events emit product_added_to_cart,
 * which the Facebook & Instagram app forwards to Meta as AddToCart (plus GA4 etc).
 * Public API: window.MgrCart.open() / close() / refresh() / add(items, {code}) / change(line, qty)
 */
(function () {
  if (window.MgrCart) return;
  var FALLBACK_SECTION = 'mgr-slide-cart';
  var ROOT_URL = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var root, toastTimer, busy = 0, lastFocus = null;

  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function getRoot() {
    if (root) return root;
    root = document.getElementById('MgrSlideCart');
    // move to <body> so a sticky / transformed header can never clip the fixed drawer
    if (root && root.parentNode !== document.body && !(window.Shopify && Shopify.designMode)) document.body.appendChild(root);
    return root;
  }
  function sid() { var r = getRoot(); return (r && r.getAttribute('data-section')) || FALLBACK_SECTION; }
  function currency() { return (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD'; }

  function setBusy(on) {
    busy = Math.max(0, busy + (on ? 1 : -1));
    var r = getRoot(); if (r) r.classList.toggle('is-busy', busy > 0);
  }

  function toast(msg) {
    var r = getRoot(); if (!r) return;
    var t = $('[data-msc-toast]', r); if (!t) return;
    t.textContent = msg; t.classList.add('is-on');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { t.classList.remove('is-on'); }, 4000);
  }

  function updateCounts(count) {
    document.querySelectorAll('[data-mgr-cart-count]').forEach(function (el) { el.textContent = count; });
    var r = getRoot(); if (r) r.classList.toggle('is-empty', count === 0);
  }

  function render(html) {
    var r = getRoot(); if (!r || !html) return;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var fresh = doc.querySelector('[data-msc-body]');
    var cur = $('[data-msc-body]', r);
    if (!fresh || !cur) return;
    var sc = $('.msc-scroll', cur), top = sc ? sc.scrollTop : 0;
    cur.innerHTML = fresh.innerHTML;
    var sc2 = $('.msc-scroll', cur); if (sc2) sc2.scrollTop = top;
    var meta = $('[data-msc-meta]', cur);
    if (meta) updateCounts(parseInt(meta.getAttribute('data-count'), 10) || 0);
  }

  function fetchSection() {
    return fetch(ROOT_URL + '?sections=' + encodeURIComponent(sid()), { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (j) { return j[sid()]; });
  }

  function refresh() {
    setBusy(true);
    return fetchSection().then(render).catch(function () {}).then(function () { setBusy(false); });
  }

  function open() {
    var r = getRoot(); if (!r) return;
    if (r.getAttribute('data-template') === 'cart') { window.location.reload(); return; }
    lastFocus = document.activeElement;
    r.classList.add('is-open'); r.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('msc-lock');
    setTimeout(function () { var p = $('.msc-panel', r); if (p) p.focus({ preventScroll: true }); }, 50);
    document.dispatchEvent(new CustomEvent('mgr:cart:open'));
  }

  function close() {
    var r = getRoot(); if (!r) return;
    r.classList.remove('is-open'); r.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('msc-lock');
    if (lastFocus && lastFocus.focus) { try { lastFocus.focus({ preventScroll: true }); } catch (e) {} }
  }

  /* ---------- tracking (Shopify customer events handle Meta; this adds GTM + optional fbq) ---------- */
  function track(items, source) {
    if (!items || !items.length) return;
    var value = 0;
    var ga = items.map(function (it) {
      var price = (it.final_price != null ? it.final_price : it.price) / 100;
      value += price * it.quantity;
      return { item_id: it.sku || String(it.variant_id), item_name: it.product_title, item_variant: it.variant_title || undefined,
        item_brand: it.vendor, price: price, quantity: it.quantity };
    });
    value = Math.round(value * 100) / 100;
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ ecommerce: null });
      window.dataLayer.push({ event: 'mgr_add_to_cart', cart_source: source, ecommerce: { currency: currency(), value: value, items: ga } });
    } catch (e) {}
    var r = getRoot();
    if (r && r.getAttribute('data-fbq') === 'true' && typeof window.fbq === 'function') {
      try {
        window.fbq('track', 'AddToCart', {
          content_type: 'product', currency: currency(), value: value,
          content_ids: items.map(function (i) { return String(i.variant_id); }),
          contents: items.map(function (i) { return { id: String(i.variant_id), quantity: i.quantity }; })
        }, { eventID: 'atc_' + Date.now() + '_' + items[0].variant_id });
      } catch (e) {}
    }
    document.dispatchEvent(new CustomEvent('mgr:cart:added', { detail: { items: items, source: source, value: value } }));
  }

  /* ---------- cart API ---------- */
  function applyCode(code) {
    if (!code) return Promise.resolve();
    return fetch(ROOT_URL + 'cart/update.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ discount: code })
    }).catch(function () {}).then(function () {
      return fetch(ROOT_URL + 'discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(ROOT_URL + 'cart.js'), { credentials: 'same-origin' }).catch(function () {});
    });
  }

  function handleAddResponse(res, code, source) {
    return res.json().then(function (data) {
      if (!res.ok || data.status) {
        var err = new Error(data.description || data.message || 'Could not add to cart');
        err.shopify = true; throw err;
      }
      track(data.items ? data.items : [data], source);
      return applyCode(code);
    });
  }

  function add(items, opts) {
    opts = opts || {};
    setBusy(true);
    return fetch(ROOT_URL + 'cart/add.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    })
      .then(function (res) { return handleAddResponse(res, opts.code, opts.source || 'api'); })
      .then(fetchSection)
      .then(function (html) { render(html); if (opts.open !== false) open(); })
      .catch(function (e) { open(); toast((e && e.message) || 'Something went wrong. Please try again.'); throw e; })
      .finally(function () { setBusy(false); });
  }

  function addFormData(fd, code, source) {
    setBusy(true);
    return fetch(ROOT_URL + 'cart/add.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: fd
    })
      .then(function (res) { return handleAddResponse(res, code, source); })
      .then(fetchSection)
      .then(function (html) { render(html); open(); })
      .finally(function () { setBusy(false); });
  }

  function change(line, qty) {
    setBusy(true);
    return fetch(ROOT_URL + 'cart/change.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: line, quantity: Math.max(0, qty || 0), sections: sid() })
    })
      .then(function (res) { return res.json().then(function (d) { return { ok: res.ok, d: d }; }); })
      .then(function (x) {
        if (!x.ok || x.d.status) { toast(x.d.description || x.d.message || 'Could not update quantity'); return refresh(); }
        if (x.d.sections && x.d.sections[sid()]) render(x.d.sections[sid()]); else return refresh();
      })
      .catch(function () { toast('Could not update your cart. Please try again.'); })
      .finally(function () { setBusy(false); });
  }

  /* reset the custom PDP buttons / flavour modal after an in-page add */
  function resetPdpUi() {
    document.querySelectorAll('[data-mgr-atc],[data-mgr-atc-sticky]').forEach(function (b) { b.dataset.mgrBusy = ''; b.style.opacity = ''; });
    document.querySelectorAll('[data-flavmodal]').forEach(function (m) {
      if (!m.hidden) { m.hidden = true; document.documentElement.style.overflow = ''; }
      var go = m.querySelector('[data-flav-go]'); if (go) go.textContent = 'Add to Cart';
    });
  }

  /* ---------- intercept every /cart/add form (hero, sticky, flavour picker, apps) ---------- */
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || f.tagName !== 'FORM' || e.defaultPrevented) return;
    var action = (f.getAttribute('action') || '').split('?')[0];
    if (!/\/cart\/add(\.js)?\/?$/.test(action) || f.hasAttribute('data-msc-skip') || !getRoot()) return;
    e.preventDefault();
    var fd = new FormData(f);
    var rt = fd.get('return_to') || '';
    fd.delete('return_to');
    var m = String(rt).match(/\/discount\/([^?\/]+)/);
    var code = m ? decodeURIComponent(m[1]) : '';
    addFormData(fd, code, f.getAttribute('data-msc-source') || 'product_form')
      .then(resetPdpUi)
      .catch(function (err) {
        resetPdpUi();
        if (err && err.shopify) { open(); toast(err.message); return; }
        // network / unknown failure: fall back to the original native POST + redirect
        f.setAttribute('data-msc-skip', '');
        f.__mgrSubmitting = true;
        HTMLFormElement.prototype.submit.call(f);
      });
  });

  /* ---------- PDP "Bulk Offers" section: take over its add-then-redirect ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-mgr-bnd-atc]');
    if (!btn || !getRoot()) return;
    e.preventDefault(); e.stopPropagation();
    var sec = btn.closest('section') || document;
    var sel = sec.querySelector('.mgr-bnd-opt.is-on') || sec.querySelector('[data-mgr-bnd]');
    var qty = sel ? (parseInt(sel.getAttribute('data-qty'), 10) || 1) : 1;
    var code = sel ? (sel.getAttribute('data-code') || '') : '';
    btn.style.opacity = '.7';
    add([{ id: parseInt(btn.getAttribute('data-variant-id'), 10), quantity: qty }], { code: code, source: 'bundles' })
      .catch(function () {}).then(function () { btn.style.opacity = ''; });
  }, true);

  /* ---------- clicks ---------- */
  document.addEventListener('click', function (e) {
    var r = getRoot(); if (!r) return;
    var t = e.target;
    if (!t.closest) return;

    var opener = t.closest('a[href],[data-msc-open]');
    if (opener && !r.contains(opener) && !e.metaKey && !e.ctrlKey && !e.shiftKey) {
      var href = opener.getAttribute('href') || '';
      var path = href.split('?')[0].split('#')[0].replace(/^https?:\/\/[^\/]+/, '');
      if (opener.hasAttribute('data-msc-open') || path === ROOT_URL + 'cart' || path === '/cart') {
        if (r.getAttribute('data-template') !== 'cart') { e.preventDefault(); open(); refresh(); return; }
      }
    }
    if (!r.contains(t)) return;

    if (t.closest('[data-msc-close]')) { e.preventDefault(); close(); return; }

    var ch = t.closest('[data-msc-change]');
    if (ch) { e.preventDefault(); change(parseInt(ch.getAttribute('data-line'), 10), parseInt(ch.getAttribute('data-qty'), 10)); return; }

    var ad = t.closest('[data-msc-add]');
    if (ad) {
      e.preventDefault();
      var card = ad.closest('.msc-rec');
      var sel = card && card.querySelector('[data-msc-variant]');
      var id = parseInt(sel ? sel.value : ad.getAttribute('data-id'), 10);
      ad.classList.add('is-busy');
      add([{ id: id, quantity: 1 }], { source: ad.getAttribute('data-source') || 'upsell' })
        .catch(function () {}).then(function () { ad.classList.remove('is-busy'); });
    }
  });

  document.addEventListener('change', function (e) {
    var inp = e.target.closest && e.target.closest('[data-msc-qty-input]');
    if (inp) change(parseInt(inp.getAttribute('data-line'), 10), parseInt(inp.value, 10) || 0);
  });

  document.addEventListener('keydown', function (e) {
    var r = getRoot();
    if (e.key === 'Escape' && r && r.classList.contains('is-open')) close();
  });

  window.addEventListener('pageshow', function (e) { if (e.persisted) refresh(); });
  document.addEventListener('mgr:cart:refresh', refresh);

  window.MgrCart = { open: open, close: close, refresh: refresh, add: add, change: change, applyCode: applyCode };

  // ?cart=open deep link (emails, ads)
  if (/[?&]cart=open\b/.test(location.search)) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', open); else open();
  }
})();